export default __webpack_public_path__ + "lightning-bolt-shadow.png";